import {funcionVacia} from './defaults.js';
/**
 * Simplifica el Console.log a logSimple pasadole el objeto a mostrar
 * @param {object} objeto parametro dato para motrar
 */
export function logSimple(objeto) {
   console.log(objeto);
}

/**
 * Agrupa los console para organizar los msg
 * @param {*} objeto Objeto el cual se imprimira en la agrupacion
 * @param {*} nombreGrupo Nombre de la agrupacion que se hizo
 * @param {*} ejecutarEnGrupo Parametro que recibe una funcion, como defecto pasa una funcion vacia
 */
export function logGrupo(objeto, nombreGrupo, ejecutarEnGrupo = funcionVacia) {
   console.group(nombreGrupo);
   console.log(objeto);
   ejecutarEnGrupo();
   console.groupEnd();
}
/**
 * Controla los tiempos de ejecucion
 * @returns retorna @start y @end que son los tiempos que demoro
 */
export function performance(callback = funcionVacia) {
   let startTime, endTime;

   function start() {
      startTime = new Date();
   }

   function end() {
      endTime = new Date();
      let timeDiff = endTime - startTime; //in ms
      callback(timeDiff, startTime, endTime);
   }
   return {start, end};
}
/**
 * Valida que el valor no sea indefinido
 * @param {*} value - Valor a validar que no se @undefined
 * @param {*} msg Mensaje a imprimir luego de validar el value
 */
export function logUndefined(value, msg) {
   if (value) {
      console.log(msg);
   }
}

export function getErrorMsg(err) {
   if (process.env.NODE_ENV !== 'production') {
      const stringErr = JSON.stringify(err);
      return stringErr === '{}' ? err.toString() : stringErr;
   } else {
      return err.toString();
   }
}
export function devLog(msg) {
   if (process.env.NODE_ENV !== 'production') {
      console.log(msg);
   }
}
/**
 *
 * @param {number} ms milisegundos a esperar
 * @returns
 */
export function timeout(ms) {
   return new Promise((resolve) => setTimeout(resolve, ms));
}
/**
 *
 * @param {number} ms milisegundos a esperar antes de ejecutar la funcion __fn__
 * @param {Function} fn function a ejecutar despues del tiempo especificaco por __ms__
 * @param  {...any} args argumento de la funcion __fn__
 * @returns
 */
export async function sleep(ms, fn, ...args) {
   await timeout(ms);
   return fn(...args);
}
